export { default as SchemaOptions } from './definitions/SchemaOptions';
export { default as validateV1 } from './functions/validate';
export { default as extractV1Metadata } from './functions/extractMetadata';
export { EVENT_TYPES, EVENTS } from './models/Event';

// domain models
export { default as DepositDocument } from './models/DepositDocument';

export const VERSION = 1;
